import { render, staticRenderFns } from "./NewOrder.vue?vue&type=template&id=2f3145fd&scoped=true&"
import script from "./NewOrder.vue?vue&type=script&lang=js&"
export * from "./NewOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3145fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f3145fd')) {
      api.createRecord('2f3145fd', component.options)
    } else {
      api.reload('2f3145fd', component.options)
    }
    module.hot.accept("./NewOrder.vue?vue&type=template&id=2f3145fd&scoped=true&", function () {
      api.rerender('2f3145fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Orders/NewOrder.vue"
export default component.exports